<template>
  <div>
    <vue-form class="form-horizontal form-validation"  :state="formstate" @submit.prevent="onSubmit">
    <b-row class="toolbar-ptc">
      <b-col>
        <router-link :to="{ name: 'user_management' }" class="btn btn-ptc1" tag="button">返回</router-link>
      </b-col>
      <b-col class="text-center title">系統管理 / 使用者管理 / 新增使用者</b-col>
      <b-col>
        <div class="text-right">
          <button class="btn btn-save" type="submit" v-if="FunctionPermission > 1">儲存</button>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-card title="新增使用者">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-12">
                  <validate tag="div">
                  <b-form-group id="exampleInputGroup1"
                                label="使用者帳號"
                                label-for="exampleInput1">
                    <b-form-input id="exampleInput1"
                                  name="exampleInput1"
                                  type="text"
                                  required
                                  placeholder="請輸入使用者帳號"
                                  v-model="account">
                    </b-form-input>
                    <field-messages name="exampleInput1" show="$invalid && $submitted" class="text-danger">
                        <div slot="required">使用者帳號為必填</div>
                    </field-messages>
                  </b-form-group>
                  </validate>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-12">
                  <validate tag="div">
                  <b-form-group id="exampleInputGroup2"
                                label="使用者姓名"
                                label-for="exampleInput2">
                    <b-form-input id="exampleInput2"
                                  name="exampleInput2"
                                  type="text"
                                  required
                                  placeholder="請輸入姓名"
                                  v-model="name">
                    </b-form-input>
                    <field-messages name="exampleInput2" show="$invalid && $submitted" class="text-danger">
                        <div slot="required">使用者姓名為必填</div>
                    </field-messages>
                  </b-form-group>
                  </validate>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-12">
                  <validate tag="div">
                  <b-form-group id="exampleInputGroup3"
                                label="使用者密碼"
                                label-for="exampleInput3">
                    <b-form-input id="exampleInput3"
                                  name="exampleInput3"
                                  type="password"
                                  required
                                  minlength="6"
                                  maxlength="12"
                                  placeholder="請輸入密碼"
                                  v-model="password">
                    </b-form-input>
                    <field-messages name="exampleInput3" show="$invalid && $submitted" class="text-danger">
                        <div v-if="v_pwd1 && v_pwd2" slot="required">&nbsp;使用者密碼為必填</div>
                        <div v-if="v_pwd1 && v_pwd2" slot="minlength">&nbsp;密碼長度限6~12位</div>
                    </field-messages>
                    <div class="text-danger" style="padding: 0.3rem" v-if="v_pwd1 === false">密碼必須有英文+數字</div>
                    <div class="text-danger" style="padding: 0.3rem" v-if="v_pwd2 === false">密碼不可有全形字元</div>
                  </b-form-group>
                  </validate>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-12">
                  <b-form-group id="exampleInputGroup4"
                                label="起始日"
                                label-for="exampleInput4">
                    <b-form-input id="exampleInput4"
                                  type="date"
                                  required
                                  v-model="sdate"
                                  :min="min_sdate">
                    </b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
          <table class="table b-table table-sm table-striped" >
            <thead class="thead-default">
              <tr>
                <th style="padding: 0.75rem; width:100px">權限角色</th>
                <th><div class="text-danger" style="padding: 0.3rem" v-if="v_role === false">請至少勾選一個角色</div>
                    <div v-else></div></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in roles" :key="item.id">
                <td style="padding: 0.75rem" colspan="2"><b-form-checkbox :value="item.id" v-model="checkedRoles" >{{item.name}}</b-form-checkbox></td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
      </b-card>
    </div>
    </vue-form>
  </div>
</template>

<script>
// for API_URL
import axios from 'axios'
import {API_URL} from '../../store/root.js'
// for 訊息視窗
import miniToastr from 'mini-toastr'
// for 功能權限function
import {getFunctionPermission} from '../../js/LoginUserFunction.js'

miniToastr.init()

const breadcrumbItems = [
  { text: '系統管理', active: true },
  { text: '權限角色管理', to: { name: 'role_management' } },
  { text: '新增角色', active: true }
]

export default {
  // name: 'HelloWorld',
  data () {
    return {
      breadcrumbItems: breadcrumbItems,
      account: '',
      password: '',
      name: '',
      sdate: '',
      edate: '',
      min_sdate: '', // 啟用日可選的最小日
      roles: [],
      checkedRoles: [],
      unCheckedRoles: [],
      v_role: true, // 角色checkbox驗證
      v_pwd1: true, // 密碼驗證(英文+數字)
      v_pwd2: true, // 密碼驗證(不可有全形)
      formstate: {}, // 驗證用
      FunctionPermission: 0 // 功能權限
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F02') // 功能權限 帶入功能代碼
    if (this.FunctionPermission > 1) {
      var date = new Date()
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()
      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.sdate = year + '-' + mon + '-' + day
      this.edate = '9999-12-31'
      this.min_sdate = year + '-' + mon + '-' + day

      this.load()
    } else if (this.FunctionPermission === 1) {
      this.$router.push({ name: 'user_management' })
    } else {
      this.$router.push({ name: 'name' })
    }
  },
  methods: {
    onSubmit: function () {
      // 自己寫驗證checkbox必填
      var arrCB = this.checkedRoles
      var isChecked = false
      this.roles.forEach(function (arrRole, Index) {
        arrCB.forEach(function (CheckItem) {
          if (arrRole.id === CheckItem) {
            isChecked = true
          }
        })
      })
      this.v_role = isChecked
      // 密碼驗證
      this.v_pwd1 = true
      this.v_pwd2 = true

      if (this.password.length >= 6 && this.password.length <= 12) {
        if (/[a-zA-Z]/.test(this.password) && /[0-9]/.test(this.password)) {
          this.v_pwd1 = true // 有英文+數字
          if (/[\uFF00-\uFFFF]/.test(this.password) || /[\u4E00-\u9fa5]/.test(this.password)) { // 全形、中文
            this.v_pwd2 = false // 全形
          } else {
            this.v_pwd2 = true // 半形
          }
        } else {
          this.v_pwd1 = false // 不符合英文+數字
        }
      }

      if (this.formstate.$invalid || this.v_role === false || this.v_pwd1 === false || this.v_pwd2 === false) {
      } else {
        // console.log('OK')
        this.add()
      }
    },
    load () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/user/page/add_role')
        .then((response) => {
          this.$parent.Loading = false
          if (response.data.result === '0000') {
            this.roles = response.data.data
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    add () {
      var arrAll = []
      var arrCB = this.checkedRoles
      var isChecked
      this.roles.forEach(function (arrRole, Index) {
        isChecked = false
        arrCB.forEach(function (CheckItem) {
          if (arrRole.id === CheckItem) {
            isChecked = true
          }
        })
        arrAll.push({
          id: arrRole.id,
          checked: isChecked
        })
      })
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/user/page/add', {
        Account: this.account,
        Password: this.password,
        Name: this.name,
        EnabledAt: this.sdate.replace('-', '').replace('-', '') + '000000',
        DisabledAt: this.edate.replace('-', '').replace('-', '') + '235959',
        Roles: arrAll
      })
        .then((response) => {
          this.$parent.Loading = false
          if (response.data.result === '0000') {
            miniToastr.success('新增成功')
            this.$router.push({ path: 'user_management' })
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.ui-breadcrumb {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/userManagementAdd.vue